import React, {useEffect, useRef, useState} from "react";
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled from "styled-components";
import icon from "../../assets/images/ui-icons_444444_256x240.png"
import {device} from "../../assets/styles/media.js";
import { ko } from "date-fns/locale";
import request from "../../config/Axios";

const StyledDatePickerWrapper = styled.div`
    .react-datepicker-wrapper {
        display: inline-block;
        position: relative;
        width: 100%;
    
    }

    .react-datepicker__input-container {
        input {
            box-sizing: border-box;
            cursor: pointer;
            padding: 9px 20px;
            width: 100%;
            height: 45px;
            color: #737373;
            border: none;
            font-size: 15px;
            border-radius: 8px;
            background-color: rgba(238, 238, 238, 0.5);
           
            &::placeholder {
                color: #bababa;
                font-size: 14px;
            }
        }
    }
 
    .react-datepicker__triangle {
        display: none;
    }

    .react-datepicker__header {
        position: relative;
        width: auto;
        font-weight: bold;
        text-align: center;
        border-top-left-radius: 0.3rem;
        border: none !important;

        ${device.tablet} {
            width: auto;
        }
    }

    .react-datepicker__current-month {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 32px;
        line-height: 32px;
        background: #e9e9e9;
        color: #333;
        border-bottom: 1px solid #aeaeae;
    }

    .react-datepicker__day-names {
        padding-top: 32px;
        background-color: #fff !important;
        
        .react-datepicker__day-name {
            border: 1px solid transparent;
        }
    }
    

    .react-datepicker__navigation {
        position: absolute;
        top: 8px;
        width: 16px;
        height: 16px;
        background: url(${icon});
        background-repeat: no-repeat;
        border: none;
        cursor: pointer;
        text-indent: -999em;
        overflow: hidden;
        padding: 0;
        z-index: 1;
    }

    .react-datepicker__navigation--previous {
        left: 10px;
        background-position: -80px -192px;
    }

    .react-datepicker__navigation--next {
        right: 10px;
        background-position: -48px -192px;
    }

    .react-datepicker__navigation-icon {
        display: none;
    }

    .react-datepicker__aria-live {
        display: none; // 시각장애인용 라이브 영역 숨김 처리
    }

    .react-datepicker__week {
        div {
            background-color: #f6f6f6;
            border: 1px solid #c5c5c5;
            color: #454545;
            font-weight: normal;
        }
    }

    .react-datepicker__day--outside-month {
        visibility: hidden; /* 또는 display: none; 도 가능 */
    }


    .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,
    .react-datepicker__month-text--selected,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--selected,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--selected,
    .react-datepicker__year-text--in-selecting-range,
    .react-datepicker__year-text--in-range
     {
        border-radius: 0 !important;
        background-color: #ffcd76 !important;
        border: none !important;
        color: #fff;
    }

    //.react-datepicker__day--today
    .react-datepicker__day--disabled {
        background-color: #cdcdcd !important;
        color: #8e8e8e !important;
    }

`


const Calendar = ({selectedDate,setSelectedDate}) => {
    const monthRef = useRef(null);
    const [minDate,setMinDate] = useState(new Date());
    const [maxDate,setMaxDate] = useState(new Date());
    const [offDate,setOffDate] = useState([]);
    const handleChange = (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd');
        setSelectedDate(formattedDate);
    };

   //휴무일
    useEffect(() => {
        (async () => {
            try {
                const offResponse = await request.get(`dayoff/datelist`);
                let data = offResponse?.data?.data.map((el)=> new Date(el));
                setOffDate(data);

                setMinDate(minDate.setDate(minDate.getDate() + 7));
                setMaxDate(maxDate.setDate(maxDate.getDate() +180))
            } catch (err) {
                console.error('api 호출 중 에러 발생:', err);
            }

        })();
    }, []);

    return (
        <StyledDatePickerWrapper>
        <DatePicker
            ref={monthRef}
            locale={ko}
            dateFormat='yyyy-MM-dd' // 날짜 형태
            shouldCloseOnSelect // 날짜를 선택하면 datepicker가 자동으로 닫힘
            minDate={minDate} // minDate 이전 날짜 선택 불가
            maxDate={maxDate}  //오늘날짜 +6개월까지 예약가능
            selected={selectedDate}
            placeholderText="예약일자를 선택해주세요"
            dateFormatCalendar={"yyyy년 LLLL"}
            onChange={handleChange}
            excludeDates={offDate}
        />
        </StyledDatePickerWrapper>
    );
};

export default Calendar;